import React from "react";
import { Routes, Route } from "react-router-dom";
import { useApp } from "../appContext";
import Layout1 from "../layout/layout1/layout1";
import Layout2 from "../layout/layout2/layout2";
import Dashboard from "../containers/dashboard";
import UserProfile from "../containers/modal/userProfile";
import CallsInProgress from "../containers/callRecords/callsInProgress";
import TimeZoneRestriction from "../containers/timeZoneRestriction";
import QueueMonitor from "../containers/liveBoards/queueMonitor/queueMonitor";
import CallReports from "../containers/reports/callReports/callReportsLaunch";
import CallReportsLaunch from "../containers/reports/callReports/callReportsLaunch";
import LegacyCdr from "../containers/callRecords/legacyCdr";
import InitialRouter from "./initialRouter";
import Loader from "../containers/loader";
import Dids from "../containers/dids.tsx/did_Management";
import DidRouter from "../containers/dids.tsx/didRouter";
import Dcid_Management from "../containers/dcid/dcid_Mangement";
import UserPanel from "../containers/liveBoards/userPanel/userPanel";
// import ScrubTool from "../containers/tools/scrubTool";
import ViewList from "../containers/tools/viewList";
import SmsUsers from "../containers/sms/smsUsers/smsUsers";
import SmsGroups from "../containers/sms/smsGroups/smsGroups";
import WallboardSettings from "../containers/liveBoards/wallboard/wallboardSettings";
import DisplayGroups from "../containers/reports/displayGroups/displayGroups";
import NewGroup from "../containers/reports/displayGroups/newGroup";
import UserPanelLaunch from "../containers/liveBoards/userPanel/userPanelLaunch";
import MyXtone from "../containers/myxtone/myXTone";
import MyXtoneLogin from "../containers/myxtone/myXtoneLogin";
import AuthenticatedIframeFetcher from "../containers/copy/iframecopy";
import WallboardCopy from "../containers/liveBoards/wallboard/wallboardCopy";
import TranscribeModal from "../containers/callRecords/transcribeModal";
import TranscribeModalCopy from "../containers/callRecords/transcribeModalCopy";
import TenantExtensions from "../containers/extensions/tenantExtensions";
import ManageTenantProvision from "../containers/extensions/modals/manageTenantProvision";
import Transcription from "../containers/analytics/transcription/transcription";
const SMTP = React.lazy(() => import("../containers/analytics/smtp/smtp"));
const Softphone = React.lazy(() => import("../containers/softphone"));
const Wallboard = React.lazy(
  () => import("../containers/liveBoards/wallboard/wallboard"),
);
const CallRecordsRoute = React.lazy(
  () => import("../containers/callRecords/callRecordsRoute"),
);
const CallReportsRoute = React.lazy(
  () => import("../containers/reports/callReports/callReportsRoute"),
);
const Login = React.lazy(() => import("../containers/auth/login/login"));
const Provision = React.lazy(() => import("../containers/provision/provision"));
const ScrubTool = React.lazy(() => import("../containers/tools/scrubTool"));
const Webhooks = React.lazy(
  () => import("../containers/tools/webhooks/webhooks"),
);
const SupervisorView = React.lazy(
  () => import("../containers/liveBoards/supervisorView/supervisorView"),
);

const RouterConfig = () => {
  const appContext = useApp();
  const { layout } = appContext;
  const Layout = layout === "layout1" ? <Layout1 /> : <Layout2 />;

  return (
    <>
      <Routes>
        <Route element={Layout}>
          <Route
            path="app/auth/login"
            element={
              <React.Suspense fallback={<></>}>
                <Login />
              </React.Suspense>
            }
          />
          {/* <Route
            path="app/"
            element={
              <React.Suspense fallback={<></>}>
                Halla
              </React.Suspense>
            }
          /> */}
          <Route
            path="app/dashboard"
            element={
              <React.Suspense fallback={<></>}>
                <Dashboard />
              </React.Suspense>
            }
          />

          <Route
            path="app/myxtone/*"
            element={
              <React.Suspense fallback={<></>}>
                <MyXtoneLogin />
              </React.Suspense>
            }
          />
          <Route
            path="app/softphone"
            element={
              <React.Suspense fallback={<></>}>
                <Softphone />
              </React.Suspense>
            }
          />
          <Route
            path="app/myxtone/login"
            element={
              <React.Suspense fallback={<></>}>
                <MyXtoneLogin />
              </React.Suspense>
            }
          />
          <Route
            path="app/myxtone/portal"
            element={
              <React.Suspense fallback={<></>}>
                <MyXtone />
              </React.Suspense>
            }
          />
          {/*  <Route
            path="app/provision/provisioning#userprofile"
            element={
              <React.Suspense fallback={<></>}>
                <UserProfile />
              </React.Suspense>
            }
          />
          <Route
            path="app/recordings/callrecordings"
            element={
              <React.Suspense fallback={<></>}>
                <LegacyCdr />
              </React.Suspense>
            }
          />
          {/* <Route
            path="app/recordings/callsinprogress"
            element={
              <React.Suspense fallback={<></>}>
                <CallsInProgress />
              </React.Suspense>
            }
          /> */}
          <Route
            path="app/recordings/callrecordings"
            element={
              <React.Suspense fallback={<></>}>
                <LegacyCdr />
              </React.Suspense>
            }
          />
          {/* check */}
          <Route
            path="app/recordings/callrecordings/transcription"
            element={
              <React.Suspense fallback={<></>}>
                <TranscribeModalCopy />
              </React.Suspense>
            }
          />
          <Route
            path="app/timeZoneRestriction"
            element={
              <React.Suspense fallback={<></>}>
                <TimeZoneRestriction />
              </React.Suspense>
            }
          />
          <Route
            path="app/liveBoards/queuemonitor"
            element={
              <React.Suspense fallback={<></>}>
                <QueueMonitor />
              </React.Suspense>
            }
          />
          <Route
            path="app/livecalls/userpanelsettings"
            element={
              <React.Suspense fallback={<></>}>
                <UserPanelLaunch />
              </React.Suspense>
            }
          />
          <Route
            path="app/livecalls/userpanelsettings/userpanel/:id"
            element={
              <React.Suspense fallback={<></>}>
                <UserPanel />
              </React.Suspense>
            }
          />
          <Route
            path="app/livecalls/supervisorview"
            element={
              <React.Suspense fallback={<></>}>
                <SupervisorView />
              </React.Suspense>
            }
          />
          <Route
            path="app/liveBoards/activecalls"
            element={
              <React.Suspense fallback={<></>}>
                <CallsInProgress />
              </React.Suspense>
            }
          />
          <Route
            path="app/liveBoards/callsinprogress"
            element={
              <React.Suspense fallback={<></>}>
                <CallsInProgress />
              </React.Suspense>
            }
          />
          <Route
            path="app/livecalls/wallboardsettings"
            element={
              <React.Suspense fallback={<></>}>
                <WallboardSettings />
              </React.Suspense>
            }
          />
          {/* <Route
            path="app/livecalls/wallboardsettings/wallboard"
            element={
              <React.Suspense fallback={<></>}>
                <Wallboard />
              </React.Suspense>
            }
          /> */}
          <Route
            path="app/livecalls/wallboardsettings/wallboard"
            element={
              <React.Suspense fallback={<></>}>
                <WallboardCopy />
              </React.Suspense>
            }
          />
          <Route
            path="app/analytics/smtp"
            element={
              <React.Suspense fallback={<></>}>
                <SMTP />
              </React.Suspense>
            }
          />
          <Route
            path="app/analytics/transcription"
            element={
              <React.Suspense fallback={<></>}>
                <Transcription />
              </React.Suspense>
            }
          />
          <Route
            path="app/reports/*"
            element={
              <React.Suspense fallback={<></>}>
                <CallReportsRoute />
              </React.Suspense>
            }
          />
          <Route
            path="app/provision/*"
            element={
              <React.Suspense fallback={<></>}>
                <Provision />
              </React.Suspense>
            }
          />
          {/* <Route           use this after myxtone is done
            path="app/sms/*"
            element={
              <React.Suspense fallback={<></>}>
                <SmsUsers />
              </React.Suspense>
            }
          /> */}

          <Route
            path="app/sms/smsusers"
            element={
              <React.Suspense fallback={<></>}>
                <SmsUsers />
              </React.Suspense>
            }
          />
          {/* <Route
            path="app/sms/myxtone"
            element={
              <React.Suspense fallback={<></>}>
                <MyXtoneLogin />
              </React.Suspense>
            }
          /> */}

          <Route
            path="app/provision/smsGroups"
            element={
              <React.Suspense fallback={<></>}>
                <SmsGroups />
              </React.Suspense>
            }
          />
          <Route
            path="app/dids/*"
            element={
              <React.Suspense fallback={<></>}>
                <Dids />
              </React.Suspense>
            }
          />
          <Route
            path="app/dcid/*"
            element={
              <React.Suspense fallback={<></>}>
                <Dcid_Management />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/scrubtool"
            element={
              <React.Suspense fallback={<></>}>
                <ScrubTool />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/scrubtool/view"
            element={
              <React.Suspense fallback={<></>}>
                <ViewList />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/scrubtool/view"
            element={
              <React.Suspense fallback={<></>}>
                <ViewList />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/activecalls"
            element={
              <React.Suspense fallback={<></>}>
                <CallsInProgress />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/displaygroups"
            element={
              <React.Suspense fallback={<></>}>
                <DisplayGroups />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/displaygroups/newgroup"
            element={
              <React.Suspense fallback={<></>}>
                <NewGroup />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/displaygroups/group/:uuid"
            element={
              <React.Suspense fallback={<></>}>
                <NewGroup />
              </React.Suspense>
            }
          />
          <Route
            path="app/tools/webhooks"
            element={
              <React.Suspense fallback={<></>}>
                <Webhooks />
              </React.Suspense>
            }
          />
          <Route
            path="app/admin/adminManagement"
            element={
              <React.Suspense fallback={<></>}>
                <TenantExtensions />
              </React.Suspense>
            }
          />
          <Route
            path="app/admin/adminManagement/provisionuser"
            element={
              <React.Suspense fallback={<></>}>
                <ManageTenantProvision />
              </React.Suspense>
            }
          />
          <Route
            path="app/admin/adminManagement/manage"
            element={
              <React.Suspense fallback={<></>}>
                <ManageTenantProvision />
              </React.Suspense>
            }
          />
          <Route
            path="app/routing"
            element={
              <React.Suspense fallback={<></>}>
                <InitialRouter />
              </React.Suspense>
            }
          />
          <Route
            path="app/loader"
            element={
              <React.Suspense fallback={<></>}>
                <div className="h-[calc(100vh-120px)] w-full bg-gray-100 flex items-center justify-center">
                  <Loader />
                </div>
              </React.Suspense>
            }
          />
          <Route
            path="app/"
            element={
              <React.Suspense fallback={<></>}>
                <InitialRouter />
              </React.Suspense>
            }
          />
          <Route
            path="app/*"
            element={
              <React.Suspense fallback={<></>}>
                <div className="h-[calc(100vh-120px)] w-[calc(100vw-120px)]  flex items-center justify-center">
                  <div className="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
                    <div className="max-w-md">
                      <div className="text-5xl font-dark font-bold text-center">
                        404
                      </div>
                      <p className="text-2xl md:text-3xl font-light leading-normal">
                        Sorry we couldn't find this page.!{" "}
                      </p>
                      {/* <p className="mb-8">
                        But dont worry, you can find plenty of other things on
                        our homepage.
                      </p>

                      <button className="px-4 inline py-2 text-sm font-medium leading-5 shadow text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-blue bg-blue-600 active:bg-blue-600 hover:bg-blue-700">
                        back to homepage
                      </button> */}
                    </div>
                    <div className="max-w-lg"></div>
                  </div>
                </div>
              </React.Suspense>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default RouterConfig;
